<template>
  <div>
    <v-card elevation="0" class="px-7">
      <v-row dense align="center" justify="space-between">
        <v-col cols="12" sm="6">
          <h1 class="fs-16 primary--text font-weight-bold">
            Dashboard
          </h1>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-breadcrumbs class="app-breadcrumbs py-3" :items="breadcrumbs" />
        </v-col>
      </v-row>
    </v-card>

    <v-container class="px-7" fluid>
      <v-row no-gutters align="center" class="mb-3">
        <v-col cols="auto">
          <v-btn to="/sshcf/dashboard" icon color="bluedarken">
            <v-icon class="icon-bold">mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6">
          <h1 class="fs-20 font-weight-bold bluedarken--text">
            Medan
          </h1>
        </v-col>
        <v-spacer />
        <v-col cols="12" sm="auto">
          <v-btn color="primary" icon large>
            <v-icon class="icon-large icon-bold" color="bluedarken">
              mdi-refresh
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-card class="elevation-card rounded-12 mb-5">
        <v-card-title>
          <div class="mr-2">
            <v-img
              src="@/assets/images/icon-file-text.png"
              width="20"
              height="20"
            />
          </div>
          <span class="fs-14 font-weight-bold bluedarken--text">
            Details Report District Medan
          </span>
          <v-spacer />
          <v-btn depressed class="btn-medium mr-4" color="#D9E7FC">
            Select Column
            <v-icon class="mr-1">mdi-chevron-down</v-icon>
          </v-btn>
          <v-btn depressed dark color="menuActive" class="btn-medium">
            Download
          </v-btn>
          <!--          <v-btn depressed class="btn-medium" color="#D9E7FC">-->
          <!--            <v-icon class="mr-1">mdi-filter-outline</v-icon>-->
          <!--            Filter-->
          <!--          </v-btn>-->
        </v-card-title>

        <v-card-text>
          <v-simple-table class="nav-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="header in headers"
                    :key="header.text"
                    class="white--text"
                    :class="{ [`text-${header.align}`]: true }"
                  >
                    <span>{{ header.text }}</span>
                    <v-icon color="white" class="ml-2 font-weight-regular">
                      mdi-filter-outline
                    </v-icon>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td class="bluedarken--text font-weight-600">
                    {{ item.code }}
                  </td>
                  <td class="bluedarken--text font-weight-600">
                    {{ item.prevalNumber }}
                  </td>
                  <td class="bluedarken--text font-weight-600">
                    {{ item.ioNumber }}
                  </td>
                  <td>{{ item.region }}</td>
                  <td>{{ item.district }}</td>
                  <td>{{ item.entity }}</td>
                  <td>{{ item.vendorCode }}</td>
                  <td>{{ item.hospitalName }}</td>
                  <td>{{ item.createdDate }}</td>
                  <td>{{ item.startDate }}</td>
                  <td>{{ item.endDate }}</td>
                  <td>{{ item.amountOfSupport | toCurrencyWithoutSign }}</td>
                  <td>{{ item.status }}</td>
                  <td class="text-center">
                    <v-btn
                      text
                      icon
                      color="primary"
                      class="text-capitalize font-weight-bold"
                    >
                      <v-icon class="">mdi-information</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr class="total">
                  <td>Total</td>
                  <td></td>
                  <td></td>
                  <td colspan="11"></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>

      <card-progress-tracking :items="steps" />
    </v-container>
  </div>
</template>

<script>
import CardProgressTracking from '@/components/SSHCF/CardProgressTracking';

export default {
  components: { CardProgressTracking },
  data: () => ({
    breadcrumbs: [
      {
        text: 'SSHCF',
        to: '/sshcf/'
      },
      {
        text: 'Dashboard',
        to: '/sshcf/dashboard/'
      },
      {
        text: 'Medan',
        disabled: true
      }
    ],
    headers: [
      {
        text: 'SSHCF Code',
        align: 'left'
      },
      {
        text: 'Preval Number',
        align: 'left'
      },
      {
        text: 'IO Number',
        align: 'left'
      },
      {
        text: 'Region',
        align: 'left'
      },
      {
        text: 'District',
        align: 'left'
      },
      {
        text: 'Entity',
        align: 'left'
      },
      {
        text: 'Vendor Code',
        align: 'left'
      },
      {
        text: 'Hospital Name',
        align: 'left'
      },
      {
        text: 'Created Date',
        align: 'center'
      },
      {
        text: 'Start Date',
        align: 'center'
      },
      {
        text: 'End Date',
        align: 'center'
      },
      {
        text: 'Amount of Support',
        align: 'center'
      },
      {
        text: 'Status',
        align: 'center'
      },
      {
        text: 'Detail',
        align: 'center'
      }
    ],
    items: [
      {
        code: '7026257',
        prevalNumber: 'LBUZ4C',
        ioNumber: 7026257,
        region: 'NS',
        district: 'Medan',
        vendorCode: '12341',
        hospitalName: 'Deli General Hospital',
        createdDate: '20-07-2020',
        startDate: '20-07-2020',
        endDate: '20-07-2020',
        amountOfSupport: 20000000,
        status: 'pending',
        detail: ''
      },
      {
        code: '7026257',
        prevalNumber: 'LBUZ4C',
        ioNumber: 7026257,
        region: 'NS',
        district: 'Medan',
        vendorCode: '12341',
        hospitalName: 'Deli General Hospital',
        createdDate: '20-07-2020',
        startDate: '20-07-2020',
        endDate: '20-07-2020',
        amountOfSupport: 20000000,
        status: 'pending',
        detail: ''
      },
      {
        code: '7026257',
        prevalNumber: 'LBUZ4C',
        ioNumber: 7026257,
        region: 'NS',
        district: 'Medan',
        vendorCode: '12341',
        hospitalName: 'Deli General Hospital',
        createdDate: '20-07-2020',
        startDate: '20-07-2020',
        endDate: '20-07-2020',
        amountOfSupport: 20000000,
        status: 'pending',
        detail: ''
      }
    ],
    steps: [
      {
        name: 'District Manager',
        complete: true,
        date: '13-06-2020'
      },
      {
        name: 'Regional Manager',
        complete: true,
        date: '15-06-2020'
      },
      {
        name: 'Regional Controller',
        complete: false
      },
      {
        name: 'Budget Owner',
        complete: false
      },
      {
        name: 'Legal',
        complete: false
      },
      {
        name: 'Department Head',
        complete: false
      },
      {
        name: 'HN Cost Control 2',
        complete: false
      }
    ]
  })
};
</script>
